import FingerprintJS from '@fingerprintjs/fingerprintjs';
import {getCookie, setCookie} from 'tiny-cookie';
import moment from 'moment/moment';
import config from '@appConfig';

const DEVICE_FINGERPRINT_COOKIE = 'ks_device_fp'; // sync: DeviceFingerprint::COOKIE_NAME (файл DeviceFingerprint.php)

let initPromise = null;

function isValidFingerprint(value) {
    return typeof value === 'string' && /^[a-zA-Z0-9]{16,64}$/.test(value);
}

function persistFingerprint(visitorId) {
    setCookie(DEVICE_FINGERPRINT_COOKIE, visitorId, {
        expires: moment().add(12, 'M').toISOString(),
        path: '/',
        domain: config.PUBLIC_DOMAIN_COOKIES || undefined,
        samesite: 'Lax',
    });
}

/**
 * Вычисляет visitorId FingerprintJS и сохраняет в cookie ks_device_fp.
 */
export function initDeviceFingerprint() {
    if (initPromise) {
        return initPromise;
    }

    initPromise = (async () => {
        const cached = getCookie(DEVICE_FINGERPRINT_COOKIE);
        if (isValidFingerprint(cached)) {
            return cached;
        }

        try {
            const agent = await FingerprintJS.load();
            const {visitorId} = await agent.get();
            if (isValidFingerprint(visitorId)) {
                persistFingerprint(visitorId);
                return visitorId;
            }
        } catch (e) {
            console.warn('Device fingerprint init failed', e);
        }

        return null;
    })();

    return initPromise;
}
